import { AfterViewInit, Directive, ElementRef, HostBinding, Input, OnDestroy } from '@angular/core';
import { UiHelper } from '../helpers/ui.helper';

@Directive({
  selector: '[badgeDirective]',
})
export class BadgeDirective implements AfterViewInit {
  /*

  Usage notes:
  <p badgeDirective >

   */

  elemID = '';
  @Input() background = 'fixed';
  @Input() color = 100;
  @Input() top = 100;
  @Input() right = 100;
  @Input() scale = 100;
  @Input() content = '0';
  // @HostBinding('style.top') elemTop: string;
  //@HostBinding('style.right') elemRight: string;
  // @HostBinding('style.background') elemBackground: string;
  @HostBinding('style.color') elemColor = '#ee3';
  @HostBinding('style.transform') elemScale: string;
  @HostBinding('style.content') elemCont: string;
  elemHeight;
  _navbarElemList = [];
  offsetCumulativer = 0;
  downCumulativer = 0;
  upCumulativer = 0;
  lastViewPortPx = 0;

  constructor(private el: ElementRef, private _UiHelper: UiHelper) {}

  ngAfterViewInit(): void {
    this.elemScale = 'scale(2)';
    this.elemColor = '#e33';
    this.elemCont = this.content;
  }
}
